import { Model } from 'vue-models'
import NumberField from './types/NumberField'
import CarrierModel from './carrier'
import CountryModel from './country'
import PortModel from './port'

export default class FreeDay extends Model {
  static defaults () {
    return {
      name: 'free day',
      basePath: 'free-days',
      computed: {
        __str__ () { return this.id }
      }
    }
  }
  static schema () {
    return {
      id: { type: Number },
      carrier: { type: CarrierModel },
      country: { type: CountryModel },
      port: { type: PortModel },

      storage_free_days: { type: NumberField },
      demurrage_free_days: { type: NumberField },
      detention_free_days: { type: NumberField }
    }
  }
}



// WEBPACK FOOTER //
// ./src/models/freeDay.js